
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.3633 13.5742H15.668C14.2137 13.5742 13.0312 14.7572 13.0312 16.2109C13.0312 17.6652 14.2137 18.8477 15.668 18.8477H33.3633C34.817 18.8477 36 17.6652 36 16.2109C36 14.7572 34.817 13.5742 33.3633 13.5742Z"}}),_c('path',{attrs:{"d":"M33.3633 22.3633H15.668C14.2137 22.3633 13.0312 23.5463 13.0312 25C13.0312 26.4543 14.2137 27.6367 15.668 27.6367H33.3633C34.817 27.6367 36 26.4543 36 25C36 23.5463 34.817 22.3633 33.3633 22.3633Z"}}),_c('path',{attrs:{"d":"M33.3633 31.1523H15.668C14.2137 31.1523 13.0312 32.3354 13.0312 33.7891C13.0312 35.2434 14.2137 36.4258 15.668 36.4258H33.3633C34.817 36.4258 36 35.2434 36 33.7891C36 32.3354 34.817 31.1523 33.3633 31.1523Z"}})])
          )
        }
      }
    